import {Component} from '@angular/core';
import {AuthService} from '../../../services/auth.service';

@Component({
  selector: 'password-reset-request',
  templateUrl: './password-reset-request.component.html'
})
export class PasswordResetRequestComponent {
  email: string;
  isSuccess: boolean = false;
  errors: any = {};

  constructor(private authService: AuthService) {
  }

  resetRequest() {
    this.isSuccess = false;
    this.errors = {};
    this.authService
      .requestPasswordReset(this.email)
      .subscribe(
        _ => this.isSuccess = true,
        response => this.errors = JSON.parse(response.error)
      );
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/auth/password-reset-request/password-reset-request.component.ts